import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: "UA-29581-90",
    params: {
      ["send_page_view"]: true
    }
  }
});

// AWS Amplify Vue with Cognito
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsConfig from "@/aws-exports";

Amplify.configure(awsConfig);
Vue.use(AmplifyPlugin, AmplifyModules);

import vuetify from "./plugins/vuetify";

import VuetifyMask from "vuetify-mask";
Vue.use(VuetifyMask);

import router from "./router";
import store from "./store";

// Filters
import "@/filters";

// Styles: SCSS
import "@/assets/scss/styles.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
